<script>
import { VBTooltip } from 'bootstrap-vue';
import { Alert } from '../../services/alert'

export default {
  props: {
    integration: {
      type: Object,
    }
  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  data () {
    return {
      config: {
        email: '',
        password: '',
        url: '',
      },
      fetching: false,
      saving: false,
      completed: false,
      alreadyExists: false,
      isEditing: false,
    };
  },

  computed: {
    webhookUrl () {
      const tenantPublicToken = this.integration.public_token;

      const domain = window.location.origin;

      return `${domain}/hook/syngootalk/${tenantPublicToken}`;
    },

    syngooConfigureWebhookUrl () {
      return `${this.config.url}/services/api`;
    }
  },

  created () {
    Bus.$on('editButtonClicked', () => {
      this.isEditing = true;
    });

    this.load();
  },

  methods: {
    goBack () {
      Bus.$emit('hideConfig');
    },

    save () {
      this.saving = true;

      // const promise =
      //   this.alreadyExists && this.integration.id ?
      //     this.update() : this.create();

      const promise = this.create();

      promise.then(() => {
        Alert.success('Configuração salva!');

        this.completed = true;
        this.isEditing = false;

        Bus.$emit('setIsEditing', false);
      }).catch((response) => {
        let message = 'Erro ao salvar configurações';

        if (
          response.status === 400
          && response.body.error
          && typeof response.body.error === 'string'
          ) {
          message = response.body.error;
        }

        Alert.error(message);
      }).finally(() => {
        this.saving = false;
      });
    },

    create () {
      return this.$http.post(`/integration/config/syngoo`, {
        config:{
          url: this.config.url,
          email: this.config.email,
          password: this.config.password,
        }
      });
    },

    update () {
      return this.$http.put(`/integration/config/${this.integration.id}`, {
        config:{
          url: this.config.url,
          email: this.config.email,
          password: this.config.password,
        }
      });
    },

    load () {
      this.fetching = true;

      this.$http.get(`/integration/config/syngoo`)
        .then((response) => {
          const { id, config } = response.body;

          if (!config.success) {
            return;
          }

          this.alreadyExists = true;
          this.completed = true;
          this.integration.id = id;
          this.config.email = config.email;
          this.config.url = config.url;

          Bus.$emit('setIsEditing', false);
        }).catch(() => {
          //
        }).finally(() => {
          this.fetching = false;
        });
    },

    copyWebhookUrlToClipboard () {
      window.navigator.clipboard.writeText(this.webhookUrl);

      Alert.success('URL copiada para seu clipboard!');
    }
  }
}
</script>

<template>
  <div v-if="fetching" class="w-100 h-100 d-flex align-items-center justify-content-center">
    <i class="fa fa-circle-o-notch fa-spin" />
  </div>
  <section id="syngoo-integration" v-else>
    <div v-if="!completed || isEditing" class="configuration">
      <p v-if="!isEditing" class="integration-info">{{ __('Para realizar a integração com a Syngoo, adicione seu e-mail e senha cadastrados na Syngoo e em seguida, clique em avançar.') }}</p>
      <p v-else class="integration-info">{{ __('Editar informações de integração com a Syngoo') }}</p>

      <form
        @submit.prevent="save"
      >

        <div>
          <div class="d-flex w-100 gap-24px mt-40px">
            <div class="d-flex flex-column w-100">
              <div class="d-flex">
                <label for="syngoo-email">E-mail</label>
                <span
                  class="email-info mt-1 ml-2"
                  title="Inserir o e-mail de um agente da Syngoo"
                  v-b-tooltip="{
                    customClass: 'salesflow-tooltip'
                  }"
                >
                  <i class="fa fa-info"></i>
                </span>
              </div>
              <input
                id="syngoo-email"
                name="syngoo-email"
                type="text"
                v-model="config.email"
              >
            </div>
            <div class="d-flex flex-column w-100">
              <label for="syngoo-password">{{ __('Senha') }}</label>
              <input
                id="syngoo-password"
                name="syngoo-password"
                type="password"
                v-model="config.password"
              >
            </div>
          </div>

          <div class="w-100 mt-4">
            <label for="syngoo-url">{{ __('URL Syngoo') }}</label>
            <input
              id="syngoo-url"
              name="syngoo-url"
              type="text"
              v-model="config.url"
            >
          </div>
        </div>

        <div class="actions-container">
          <button
            id="go-back-button"
            v-if="isEditing"
            @click="goBack"
          >
            {{ __('Cancelar') }}
          </button>
          <button
            id="advance-button"
            class="salesflow-btn salesflow-btn-primary"
            type="submit"
            :disabled="saving"
          >
            {{ isEditing ? __('Salvar') : __('Avançar') }}
            <IconSalesflowChevron v-if="!isEditing" class="ml-2" color="#FFFFFF" />
          </button>
        </div>
      </form>
    </div>
    <div v-else class="completed">
      <p class="success-text mt-2">
        {{ __('Parabéns, sua conta com a Syngoo.talk está conectada!') }}
      </p>
      <p class="instructions-text mb-40px">
        {{ __('Para concluir sua integração, copie e cole o código abaixo e insira na sua conta Syngoo.talk.') }}
      </p>

      <div class="webhook-url-container d-flex flex-column mb-40px mx-auto">
        <label for="webhook-url">{{ __('URL Webhook') }}</label>
        <span id="webhook-url">
          <input
            id="webhook-url"
            name="webhook-url"
            type="text"
            :value="webhookUrl"
          >
          <button @click="copyWebhookUrlToClipboard">
            <IconCopy color="#242424" :size="16" />
          </button>
        </span>
      </div>

      <p class="syngoo-info">
        {{ __('Dúvidas sobre como inserir o URL webhook na Syngoo.talk?') }}
        <a :href="syngooConfigureWebhookUrl">{{ __('Clique aqui') }}</a> {{ __('e saiba mais') }}
      </p>
    </div>
  </section>
</template>

<style lang="scss" scoped>
  @import '../../../sass/variables';
  @import '../../../sass/mixins';

  #syngoo-integration {
    // min-height: 62.5vh;

    .configuration {
      width: 100%;

      .integration-info {
        @include salesflow-text;
        margin-top: 58px;
        text-align: center;
      }

      form {
        label {
          @include salesflow-subtitle($font-weight: 500, $color: $salesflow-font-dark);
          margin-bottom: 0.5rem;
        }

        .email-info {
          width: 0.875rem;
          height: 0.875rem;
          display: grid;
          place-items: center;
          border-radius: 100%;
          background-color: $salesflow-primary;

          i {
            font-size: 0.5rem;
            color: white;
          }
        }

        input {
          width: 100%;
          padding: 0.75rem 1rem;
          background-color: white;
          border: 1px solid $salesflow-outline-gray-medium;
          border-radius: 8px;
          @include salesflow-text;
        }

        .actions-container {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 24px;
          margin-top: 48px;

          #go-back-button {
            padding: 0.75rem 1.125rem;
            @include salesflow-subtitle($font-weight: 600, $color: $salesflow-primary);
            background-color: white;
            border: 1px solid $salesflow-primary;
            border-radius: 14px;

            &:hover {
              cursor: pointer;
              background-color: $salesflow-primary-hover;
              color: white;
            }
          }

          #advance-button {
            &:disabled {
              opacity: 0.7;
              cursor: wait;
            }
          }
        }
      }
    }

    .completed {
      margin-top: 56px;

      .success-text {
        @include salesflow-subtitle($color: $salesflow-font-dark, $font-weight: 700);
        font-size: 1.25rem;
        text-align: center;
      }

      .instructions-text {
        @include salesflow-text;
        font-size: 0.875rem;
        text-align: center;
      }

      label {
        @include salesflow-subtitle($font-weight: 500, $color: $salesflow-font-dark);
        margin-bottom: 0.5rem;
      }

      .webhook-url-container {
        width: 710px;
      }

      #webhook-url {
        width: 100%;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.75rem 1rem;
        background: #E2E8F066;
        border: 1px solid $salesflow-outline-gray-medium;
        border-radius: 8px;
        @include salesflow-text;

        input {
          width: 100%;
          height: 100%;
          background-color: transparent;
          padding: 0px;
          border: 0px;
          outline: 0px;
          border-radius: 0px;
        }

        button {
          background-color: transparent;
          border: none;
          outline: none;
          padding: 0px;
        }
      }

      .syngoo-info {
        @include salesflow-text;
        text-align: center;

        a {
          font-weight: 600;
          text-decoration: underline;
          color: $salesflow-primary;

          &:hover {
            cursor: pointer;
            color: $salesflow-primary-hover;
          }
        }
      }
    }

    .gap-24px {
      gap: 24px;
    }
  }
</style>
